export default __webpack_public_path__ + "static/media/icon-dev.141103340697d747b5ddfd2909eb56f4.svg";